module.exports = __webpack_public_path__ + "img/1.a1a5a82e.jpg";